import { Button, Modal, ModalBody, ModalHeader } from "flowbite-react";
import { useState } from "react";
import { HiOutlineExclamationCircle } from "react-icons/hi";
import { toast } from "react-toastify";
import { deletePlaylist } from "../../services/radio";

interface DeletePlaylistModalProps {
  playlist: {
    id: string;
    title: string;
  };
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  onDeleted: () => void;
}

const DeletePlaylistModal = function (props: DeletePlaylistModalProps) {
  const { playlist, isOpen, setIsOpen } = props;
  const [deleting, setDeleting] = useState(false);

  const handleDeletePlaylist = async () => {
    setDeleting(true);
    try {
      await deletePlaylist(playlist.id);
      toast.success(`Playlist "${playlist.title}" deleted successfully`);
      props.onDeleted();
    } catch (error) {
      console.error("Error deleting playlist", error);
      toast.error("Failed to delete playlist");
    }
    setDeleting(false);
    setIsOpen(false);
  };

  return (
    <Modal
      size="md"
      position="top-center"
      show={isOpen}
      onClose={() => setIsOpen(false)}
    >
      <ModalHeader className="px-6 pb-0 pt-6">
        <span className="sr-only">Delete Playlist</span>
      </ModalHeader>
      <ModalBody className="px-6 pb-6 pt-0">
        <div className="flex flex-col items-center gap-y-4 text-center">
          <HiOutlineExclamationCircle className="text-7xl text-red-500" />
          <p className="text-xl text-gray-500">
            Are you sure you want to delete the playlist "{playlist.title}"?
          </p>
          <p className="text-sm text-gray-400">This action cannot be undone.</p>
          <div className="flex items-center gap-x-3">
            <Button
              color="failure"
              disabled={deleting}
              onClick={handleDeletePlaylist}
            >
              {deleting ? "Deleting..." : "Yes, I'm sure"}
            </Button>
            <Button color="light" onClick={() => setIsOpen(false)}>
              No, cancel
            </Button>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default DeletePlaylistModal;
